export const MinMaxSelectEventType = {
  Click: 'click',
  Change: 'change',
};

export const MinMaxSelectId = {
  Min: 'min',
  Max: 'max',
};

export const MinMaxSelectProperty = {
  ClassName: 'className',
  Value: 'value',
  Label: 'label',
  MinValues: 'minValues',
  MaxValues: 'maxValues',
  IconColor: 'iconColor',
  ColorScheme: 'colorScheme',
  LabelColorScheme: 'labelColorScheme',
  FillType: 'fillType',
  Disabled: 'disabled',
  IsReadonly: 'isReadonly',
  Variant: 'variant',
};

export const MinMaxSelectVariant = {
  Dropdown: 'dropdown',
  Plain: 'Plain',
};

export const TEST_OPTIONS = [
  {
    text: '1',
    value: 1,
  },
  {
    text: '2',
    value: 2,
  },
  {
    text: '3',
    value: 3,
  },
];

export default {
  MinMaxSelectEventType,
  MinMaxSelectId,
  MinMaxSelectProperty,
  TEST_OPTIONS,
};
